export const creditPolicyRoutes = [
  {
    path: '/configuracoes/politicas-de-credito',
    name: 'CreditPolicies',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'config'
    },
    component: () => import(/* webpackChunkName: 'credit-policies-page' */ 'views/CreditPoliciesPage')
  }
]
